<div>
    <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
</div>

<div class="container-fluid">

    <div>
        <h5 id="headerLabel"> No new data will be available for this report after 10/15/2024</h5>
        <br>
    </div>

    <div class="row">
        <div class="col-12">
            <p-table 
                styleClass="p-datatable-striped" 
                id="monthEndTable"
                [columns]="tableColumn" 
                [value]="monthEndReports"
                [scrollable]="true" scrollHeight="50vh">
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="monthEndReports.length > 0">
                    <th [style.width.%]="col.width" *ngFor="let col of columns"  class="noBorder" >
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" >
                <tr>
                    <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
    
                        <div *ngSwitchCase="'startDate'">
                            <a *ngIf="rowData.fileName" href="javascript:void(0)" (click)="downloadReport(rowData)">
                                {{rowData[col.field] | industryMonReport}}
                            </a>
                            <span *ngIf="!rowData.fileName">{{rowData[col.field] | industryMonReport}}</span>
                            
                        </div>
    
                        <div *ngSwitchDefault>{{rowData[col.field]}}</div>
                        
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns.length" class="noBorder">
                        <b>There are no reports at this time.</b>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        </div>
    </div>
</div>
